import React from 'react';
import Navbar from '../components/Navbar';
import DefenseHero from '../components/defense/DefenseHero';
import DefenseProblem from '../components/defense/DefenseProblem';
import WhyTraainDefense from '../components/defense/WhyTraainDefense';
import TrainingIntelligenceDefense from '../components/defense/TrainingIntelligenceDefense';
import RolePlayIntelligenceDefense from '../components/defense/RolePlayIntelligenceDefense';
import ExchangeDefense from '../components/defense/ExchangeDefense';
import DefenseCTA from '../components/defense/DefenseCTA';
import Footer from '../components/Footer';

const DefensePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-cyan-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <DefenseHero />
        <DefenseProblem />
        <WhyTraainDefense />
        <TrainingIntelligenceDefense />
        <RolePlayIntelligenceDefense />
        <ExchangeDefense />
        <DefenseCTA />
        <Footer />
      </div>
    </div>
  );
};

export default DefensePage;
